<template>
  <div class="card">
    <div
      class="card-body"
      v-if="!reportEntry"
    >
      <p class="card-text mb-3">
        Import History
      </p>
      <div class="row">
        <div class="col-lg-6">
          <form @submit.prevent="search">
            <div class="form-row">
              <div class="form-group col-md-6">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Your login or property's id here ..."
                  :disabled="disabled"
                  v-model="login"
                >
              </div>
              <div class="form-group col-md-4">
                <select
                  class="form-control"
                  :disabled="disabled"
                  v-model="schema"
                >
                  <option value="">
                    Select schema
                  </option>
                  <option value="kyero">
                    Kyero
                  </option>
                  <option value="thinkspain">
                    ThinkSpain
                  </option>
                  <option value="ego">
                    Ego
                  </option>
                  <option value="adaix">
                    Adaix
                  </option>
                  <option value="xml2u">
                    XML2U
                  </option>
                  <option value="habitania">
                    Habitania
                  </option>
                  <option value="sooprema">
                    Sooprema
                  </option>
                  <option value="inmobalia">
                    Inmobalia
                  </option>
                  <option value="inmofactory">
                    Inmofactory
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <button
                  class="btn btn-outline-primary"
                  type="submit"
                  :disabled="disabled"
                >
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-lg-6">
          <form @submit.prevent="startImport( importLogin, forceDbCheck, dryrun, reprocessLastSuccessful )">
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                placeholder="Login to start import for ..."
                v-model="importLogin"
                required
              >
            </div>
            <div class="input-group form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="forceDbCheck"
              >
              <label class="form-check-label">Run against db</label>
            </div>
            <div class="input-group form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="dryrun"
              >
              <label class="form-check-label">Dry run</label>
            </div>
            <div class="input-group form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="reprocessLastSuccessful"
              >
              <label class="form-check-label">Reprocess last successful</label>
            </div>
            <div class="input-group-append">
              <button
                class="btn btn-outline-primary"
                type="submit"
              >
                Start import
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      v-if="!reportEntry"
    >
      <table class="table table-striped">
        <thead>
          <th>Run</th>
          <th>Agent</th>
          <th>Config</th>
          <th>Start</th>
          <th>End</th>
          <th>Processing Stats</th>
          <th>Processing Error</th>
          <th>DB Write Error</th>
          <th>Changelog</th>
          <th>Report</th>
          <th>Run import</th>
        </thead>
        <tbody>
          <tr
            v-for="entry in entries"
            :key="entry.id"
          >
            <td>{{ entry.id }}</td>
            <td>{{ entry.agentCode }}</td>
            <td>
              <ul>
                <li>
                  properties: {{ entry.runConfig.numberOfProperties }} <span v-if="validPromotion( entry )">(upgraded to {{ entry.runConfig.promotionalProperties }})</span>
                  <br>
                  swap feed: {{ entry.runConfig.swapFeed }}
                  <br>
                  schema: {{ entry.runConfig.importSchema }}
                  <br>
                  order: {{ order( entry ) }}
                  <br>
                  feed: {{ eclipseMiddle( entry.runConfig.importUrl ) }}
                  <br v-if="entry.runConfig.cleanDescriptions">
                  <span v-if="entry.runConfig.cleanDescriptions">clean descriptions: {{ entry.runConfig.cleanDescriptions }}</span>
                </li>
                <li v-if="entry.runConfig.noSales">
                  No Sales
                </li>
                <li v-if="entry.runConfig.noLongTerm">
                  No Long Term rentals
                </li>
                <li v-if="entry.runConfig.noHoliday">
                  No holiday rentals
                </li>
              </ul>
            </td>
            <td>{{ toLocaleString( entry.start ) }}</td>
            <td>{{ toLocaleString( entry.end ) }}</td>
            <td>
              <ul v-if="entry.processingStats">
                <li>
                  valid: {{ entry.processingStats.online }}
                </li>
                <li>
                  valid over service limit: {{ entry.processingStats.offline }}
                </li>
                <li>
                  invalid: {{ entry.processingStats.invalid }}
                </li>
                <li>
                  excluded: {{ entry.processingStats.unmatched + (entry.processingStats.ignored ? entry.processingStats.ignored : 0) }}
                </li>
              </ul>
            </td>
            <td
              class="processing-error-cell"
            >
              {{ entry.processingError }}
            </td>
            <td>{{ formatDbError(entry.dbWriteError) }}</td>
            <td>
              <ul v-if="entry.changeLog">
                <li v-if="entry.changeLog.total">
                  total: {{ entry.changeLog.total }}
                </li>
                <li v-if="entry.changeLog.inserted">
                  inserted: {{ entry.changeLog.inserted.length }}
                </li>
                <li v-if="entry.changeLog.offline">
                  offline: {{ entry.changeLog.offline.length }}
                </li>
                <li v-if="entry.changeLog.updated">
                  updated: {{ Object.keys(entry.changeLog.updated).length }}
                </li>
              </ul>
            </td>
            <td>
              <button
                class="btn btn-outline-secondary"
                v-if="entry.end"
                @click="viewReport ( entry )"
              >
                view report
              </button>
            </td>
            <td>
              <button
                class="btn btn-outline-primary"
                @click="startImport ( entry.agentCode, false, false )"
              >
                start new import
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="entries.length > 0">
        <button
          class="btn btn-outline-primary"
          @click="loadMore"
        >
          Load more
        </button>
      </div>
    </div>
    <Report
      :report-entry="reportEntry"
      :show-reprocess-action="false"
      @close="reportEntry = null;"
    />
  </div>
</template>

<script>
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';
import Report from './report.vue';

export default {
    components: {
        Report
    },
    data() {
        return {
            disabled: false,
            login: '',
            schema: '',
            entries: [],
            importLogin: '',
            forceDbCheck: false,
            dryrun: false,
            reprocessLastSuccessful: false,
            reportEntry: null
        };
    },
    async mounted() {
        if ( this.$route.query.login ) {
            this.login = this.$route.query.login;
        }
        if ( this.$route.query.schema ) {
            this.schema = this.$route.query.schema;
        }
        this.search();
    },
    methods: {
        eclipseMiddle( url ) {
            if ( !url ) {
                return '';
            }

            if ( url.length < 50 ) {
                return url;
            }

            return url.substring( 0, 25 ) + ' ... ' + url.substring( url.length - 10 );
        },
        validPromotion( entry ) {
            if ( !entry.runConfig.promotionStartDate || !entry.runConfig.promotionEndDate ) {
                return false;
            }
            const promotionStartDate = new Date( entry.runConfig.promotionStartDate );
            const promotionEndDate = new Date( entry.runConfig.promotionEndDate );

            const start = new Date( entry.start );

            return start >= promotionStartDate && start <= promotionEndDate;
        },
        order( entry ) {
            if ( !entry.runConfig.sortType ) {
                return '';
            }

            switch ( entry.runConfig.sortType ) {
            case 0:
                return 'with photos, as in the feed';
            case 1:
                return 'with photos, date descending';
            case 2:
                return 'with photos, price ascending';
            case 3:
                return 'with photos, price descending';
            case 4:
                return 'manual';
            case 5:
                return 'custom';
            default:
                return 'unknown';
            }
        },
        formatDbError( dbError ) {
            if ( !dbError ) {
                return '';
            }

            if ( dbError.length < 300 ) {
                return dbError;
            }

            return dbError.substring( 0, 300 ) + ' ...';
        },
        async viewReport( entry ) {
            this.reportEntry = entry;
        },
        async startImport( agentCode, forceDbCheck, dryrun, reprocessLastSuccessful ) {
            // check if agent is configured for XML import

            let propertyServicesCall = await xmlimportsapi.get( `/agent/${agentCode}/propertyservice` );

            if ( propertyServicesCall.status != 200 && propertyServicesCall.status != 404 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to start import'
                } );
                return;
            }

            if ( propertyServicesCall.status == 404 ) {
                if ( !confirm( 'Agent or service not found. Do you want to start the import anyway?' ) ) {
                    return;
                }
            }

            let propertyServices = await propertyServicesCall.json();

            if ( propertyServices.ImportType != 'XML' ) {
                let msg = `Agent is not configured for XML import (${propertyServices.ImportType} import type). Do you want to start the import anyway?`;
                if ( !confirm( msg ) ) {
                    return;
                }
            }

            let url = 'run/' + agentCode;

            if ( forceDbCheck ) {
                url += '?forcedbcheck=true';
            }

            if ( dryrun ) {
                url += '?dryrun=true';
            }

            if ( reprocessLastSuccessful ) {
                url += '?reprocessLastSuccessful=true';
            }

            const response = await xmlimportsapi.post( url );

            if ( response.status !== 200 && response.status !== 202 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to start import'
                } );
                return;
            }

            notify( {
                type: 'success',
                text: 'Import started',
                title: 'Success'
            } );
        },
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );

            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        async search() {
            // if this.login looks like a big number over 1 million, it's probably somebody looking for property id
            // so we don't want to search for it, we first find a login by /property/{id} and then search for that login

            if ( this.login && this.login.length > 6 ) {
                const number = parseInt( this.login );

                if ( number > 1000000 ) {
                    const response = await xmlimportsapi.get( '/property/' + number );

                    if ( response.status !== 200 ) {
                        notify( {
                            type: 'error',
                            text: 'Something went wrong',
                            title: 'Failed to find login for property'
                        } );
                        this.disabled = false;

                        return;
                    }

                    const responseJson = await response.json();

                    if ( responseJson.agent ) {
                        this.login = responseJson.agent;
                    } else {
                        notify( {
                            type: 'error',
                            text: 'Property not found',
                            title: 'Failed to find login for property'
                        } );
                        this.disabled = false;

                        return;
                    }
                }
            }

            this.disabled = true;
            this.$store.dispatch( 'appLoading', true );

            var url = '/history';

            if ( this.login ) {
                url += '/' + this.login;
            }

            url += '?take=120';

            if ( this.schema ) {
                url += '&schema=' + this.schema;
            }

            function normalize( val ) {
                return val == null ? '' : val;
            }

            if ( normalize( this.login ) !== normalize( this.$route.query.login ) || normalize( this.schema ) !== normalize( this.$route.query.schema ) ) {
                let args = {};

                if ( this.login && this.$route.query.login !== this.login ) {
                    args.login = this.login;
                }

                if ( this.schema ) {
                    args.schema = this.schema;
                }
            }

            const response = await xmlimportsapi.get( url );

            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load import history'
                } );
                this.disabled = false;

                return;
            }

            const responseJson = await response.json();

            this.entries = responseJson || [];

            this.disabled = false;
        },
        async loadMore() {
            // if this.login looks like a big number over 1 million, it's probably somebody looking for property id
            // so we don't want to search for it, we first find a login by /property/{id} and then search for that login

            this.disabled = true;
            this.$store.dispatch( 'appLoading', true );

            var url = '/history';

            if ( this.login ) {
                url += '/' + this.login;
            }

            url += '?take=120';

            if ( this.schema ) {
                url += '&schema=' + this.schema;
            }

            // load min report entry id to populate for 'beforeId' param
            let minId = 0;
            
            if ( this.entries.length > 0 ) {
                minId = this.entries[ this.entries.length - 1 ].id;
                url += '&beforeId=' + minId;
            }

            const response = await xmlimportsapi.get( url );

            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load import history'
                } );
                this.disabled = false;

                return;
            }

            const responseJson = await response.json();

            this.entries = this.entries.concat( responseJson || [] );

            this.disabled = false;
        }
    }
};
</script>

<style scoped>
  .processing-error-cell {
    max-width: 200px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/history.vue